// Paleta de cores das bandeirinhas — mesma do JukeboxJuninaBanner
const CORES_VARAL = ['#dc2626', '#f97316', '#eab308', '#16a34a', '#2563eb', '#9333ea'];
const TOTAL = 22;

export default function JukeboxFestaJuninaBanner() {
  return (
    <div className="animate-fade-in overflow-hidden relative">
      <div className="bg-[linear-gradient(to_bottom,rgba(120,53,15,0.18)_0%,rgba(234,179,8,0.05)_60%,transparent_100%)] border-b border-yellow-500/[0.12] pb-2">

        {/* Varal de bandeirinhas */}
        <div className="relative px-0 pt-0">
          <div className="absolute top-2 inset-x-0 h-px bg-[linear-gradient(to_right,transparent,rgba(161,120,10,0.45)_10%,rgba(161,120,10,0.45)_90%,transparent)]" />
          <svg
            width="100%"
            height="24"
            viewBox={`0 0 ${TOTAL * 18} 24`}
            preserveAspectRatio="none"
            aria-hidden
          >
            {Array.from({ length: TOTAL }, (_, i) => {
              const cor = CORES_VARAL[i % CORES_VARAL.length];
              const x   = i * 18 + 1;
              return (
                <polygon
                  key={i}
                  points={`${x},2 ${x + 14},2 ${x + 7},20`}
                  fill={cor}
                  opacity={0.88}
                  className="animate-junina-balanco"
                  style={{ transformOrigin: `${x + 7}px 2px`, animationDelay: `${i * 60}ms` }}
                />
              );
            })}
          </svg>
        </div>

        <div className="flex items-center justify-center gap-2 pt-1">
          <p
            className="animate-junina-titulo-glow font-black uppercase text-center text-[10px] tracking-[0.22em] text-yellow-200/90"
            style={{ textShadow: '0 0 12px rgba(234,179,8,0.35)' }}
          >
            Arraiá do Espetos
          </p>
        </div>
      </div>
    </div>
  );
}
